import { useQuery } from "@tanstack/react-query";
import React from "react";
import { getSettlementTransactions } from "src/api/accounts";
import CustomDataTable from "../CustomDataTable";
import { renderCurrency } from "src/lib/utils";
import { format } from "date-fns";

const columns = [
	{ name: "S/N", selector: (_, index) => index + 1, width: "60px" },
	{ name: "Reference", selector: (row) => row.reference, grow: 1.5, wrap: true },
	{ name: "Amount", selector: (row) => renderCurrency(row.amount) },
	{ name: "Date", selector: (row) => format(row.updated_at, "Pp"), grow: 1.5, wrap: true },
];

const SettlementTransactions = ({ uuid }) => {
	const { data, isLoading } = useQuery({
		queryKey: ["settlement-transactions"],
		queryFn: () => getSettlementTransactions({ uuid }),
		suspense: true,
	});

	const transactions = data?.data?.data;

	return (
		<div className="max-md:tw-w-[calc(100%)]">
			<CustomDataTable
				data={transactions}
				columns={columns}
				progressPending={isLoading}
				customStyles={{
					rows: {
						style: {
							paddingBlock: "0.25rem",
							paddingInline: "10px",
						},
					},
					headRow: {
						style: {
							paddingInline: "10px",
						},
					},
				}}
			/>
		</div>
	);
};

export default SettlementTransactions;
